export default __webpack_public_path__ + "static/media/gournay3.2e93b5c7.jpg";